import React from 'react';

const About = () => {
    return(
        <React.Fragment>
        <h1>About this app</h1>
        <p>App to Search GitHub Users</p>
        <p>Version: 1.0.0</p>
        </React.Fragment>
    )
}
export default About;